// extracted by mini-css-extract-plugin
module.exports = {"CheckboxMenu":"CheckboxMenu--1XsXk"};